import { Hero } from "@/components/home/Hero";
import { Vision } from "@/components/home/Vision";
import { Sectors } from "@/components/home/Sectors";
import { Stats } from "@/components/home/Stats";
import { Philosophy } from "@/components/home/Philosophy";
import { MapSection } from "@/components/home/MapSection";
import { Ecosystem } from "@/components/home/Ecosystem";
import { FinalCta } from "@/components/home/FinalCta";
import { useSeo } from "@/lib/seo";

export default function Home() {
  useSeo({
    title: "Losta Group — Holding d'acquisition et de développement d'entreprises | France & Suisse",
    description:
      "Losta Group acquiert, fédère et développe des PME de la communication visuelle et des métiers techniques complémentaires. Rachat et transmission d'entreprises en France et en Suisse.",
    path: "/",
  });
  return (
    <>
      <Hero />
      <Vision />
      <Sectors />
      <Stats />
      <Philosophy />
      <MapSection />
      <Ecosystem />
      <FinalCta />
    </>
  );
}
